import React, { createContext, useContext, useEffect, useState } from 'react';
import io from 'socket.io-client';
import { useAuth } from './AuthContext';

const SocketContext = createContext();
export const useSocket = () => useContext(SocketContext);

export const SocketProvider = ({ children }) => {
  const { token } = useAuth();
  const [socket, setSocket] = useState(null);

  useEffect(() => {
    if (!token) {
      if (socket) socket.disconnect();
      setSocket(null);
      return;
    }

    let socketUrl;
    if (process.env.REACT_APP_SOCKET_URL) {
      socketUrl = process.env.REACT_APP_SOCKET_URL;
    } else if (process.env.REACT_APP_API_URL) {
      socketUrl = process.env.REACT_APP_API_URL.replace('/api', '');
    } else if (window.location.hostname === 'localhost') {
      socketUrl = 'http://localhost:5000';
    } else {
      socketUrl = window.location.origin;
    }

    const newSocket = io(socketUrl, {
      auth: { token },
      transports: ['websocket', 'polling'],
      reconnection: true,
      withCredentials: true,
    });

    newSocket.on('connect', () => console.log('Socket connected'));
    newSocket.on('connect_error', (err) => console.error('Socket error:', err.message));

    setSocket(newSocket);
    return () => newSocket.disconnect();
  }, [token]);

  return <SocketContext.Provider value={socket}>{children}</SocketContext.Provider>;
};